export default __webpack_public_path__ + "static/media/Icon denied.7e0ed9ae.svg";